module.exports = __webpack_public_path__ + "media/images/Adherent-default-6baa6260a7e6ee04ee3aae79816fe623.png";